module.exports = __webpack_public_path__ + "media/images/design/images/bn_csr-51da1f5a1b24f074d3562f208a760bfe.jpg";